import { dia, ui, layout } from '@joint/plus';
import { members } from './data';
import { Member, Link, cellNamespace } from './shapes';
var COLUMNS = 3;
var MEMBER_WIDTH = 250;
var MEMBER_HEIGHT = 30;
export var LABEL_OFFSET = 10;
var STACK_ELEMENT_GAP = 5;
var STACK_GAP = 0;
var PADDING = 20;
export var init = function () {
    var graph = new dia.Graph({}, { cellNamespace: cellNamespace });
    var el = document.getElementById('canvas');
    var paper = new dia.Paper({
        el: el,
        width: COLUMNS * MEMBER_WIDTH + PADDING * 2 + STACK_GAP * (COLUMNS - 1),
        height: members.length * (MEMBER_HEIGHT + STACK_ELEMENT_GAP) - STACK_ELEMENT_GAP + PADDING * 2,
        model: graph,
        cellViewNamespace: cellNamespace,
        interactive: false,
        async: true,
        frozen: true,
        background: { color: '#FBFBFB' },
        defaultConnectionPoint: { name: 'anchor' },
        defaultAnchor: function (elementView) {
            var element = elementView.model;
            var stackIndex = element.get('stackIndex');
            if (stackIndex === 0) {
                return element.getBBox().rightMiddle();
            }
            return element.getBBox().leftMiddle();
        },
        defaultConnector: { name: 'curve' }
    });
    addTeam(members, graph, paper);
    var layoutOptions = {
        stackCount: COLUMNS,
        stackSize: MEMBER_WIDTH,
        direction: layout.StackLayout.Directions.TopBottom,
        topLeft: {
            x: PADDING,
            y: PADDING
        },
        stackElementGap: STACK_ELEMENT_GAP,
        stackGap: STACK_GAP
    };
    var stackLayoutView = new ui.StackLayoutView({
        paper: paper,
        layoutOptions: layoutOptions,
        validateMoving: function (dragData) { return (dragData.sourceStack.index === dragData.targetStack.index); },
        canInteract: function (elementView) { return (elementView.model.get('stackIndex') !== 0); }
    });
    var toolbar = new ui.Toolbar({
        el: document.querySelector('#toolbar'),
        tools: [
            { type: 'button', name: 'shuffle', text: 'Shuffle' }
        ]
    });
    stackLayoutView.model.on('update', function () {
        stackLayoutView.model.stacks[COLUMNS - 1].elements.forEach(function (member, i) {
            member.attr({
                label: { text: "".concat(i + 1) }
            });
        });
    });
    toolbar.on('shuffle:pointerclick', function () { return shuffleTeam(stackLayoutView); });
    shuffleTeam(stackLayoutView);
    toolbar.render();
    paper.unfreeze();
};
var addTeam = function (teamMembers, graph, paper) {
    teamMembers.forEach(function (member, i) {
        var member1 = new Member({
            size: {
                width: MEMBER_WIDTH,
                height: MEMBER_HEIGHT
            },
            attrs: {
                name: { text: member.name },
                label: { text: member.name.charAt(0).toUpperCase() },
                labelBg: { fill: member.color }
            },
            stackIndex: 0,
            stackElementIndex: i
        });
        var labelOffset = LABEL_OFFSET + MEMBER_HEIGHT;
        var member2 = member1.clone().set('stackIndex', COLUMNS - 1);
        member2.attr({
            name: { x: labelOffset },
            labelBg: { x: 0 },
            label: { x: MEMBER_HEIGHT / 2, text: "".concat(i + 1) }
        });
        var link = new Link({ attrs: { line: { stroke: member.color } } });
        link.source(member1).target(member2);
        graph.addCells([member1, member2, link]);
        member2.findView(paper).vel.addClass('draggable');
    });
};
var shuffleTeam = function (stackLayoutView) {
    var _a;
    var stackModel = stackLayoutView.model;
    var stackMembers = stackModel.stacks[COLUMNS - 1].elements;
    for (var i = stackMembers.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        _a = [stackMembers[j], stackMembers[i]], stackMembers[i] = _a[0], stackMembers[j] = _a[1];
        stackMembers[i].set('stackElementIndex', i);
        stackMembers[j].set('stackElementIndex', j);
    }
    stackModel.update();
};
